// ===== HERO SECTION ANIMATION =====
function initHeroAnimation() {
  const heroImageElement = document.querySelector(".hero-image-element");
  const heroImageOverlay = document.querySelector(".hero-image-overlay");
  const heroGradientOverlay = document.querySelector(
    ".hero-section-gradient-overlay"
  );
  console.log(heroGradientOverlay);
  const heroContent = document.querySelector(".hero-content");
  const heroSection = document.querySelector(".hero-section");
  const headerLogo = document.querySelector(".header-logo, #header-logo");

  if (heroImageElement && heroImageOverlay && heroContent && window.gsap) {
    // Create hero animation timeline
    const heroTimeline = gsap.timeline({ delay: 0.5 });

    heroTimeline
      // Phase 1: Fade in content (0.8s duration, starts immediately)
      .to(
        heroContent,
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
        },
        0
      )

      // Phase 2: Fade in overlay gradient (0.5s duration, starts at 1.5s)
      .to(
        [heroImageOverlay, heroGradientOverlay],
        {
          opacity: 0.75,
          duration: 0.5,
          ease: "power2.out",
        },
        1.5
      );

    console.log("Hero animation initialized");
  } else {
    console.log("Hero animation elements not found or GSAP not loaded");
    console.log("heroImageElement:", heroImageElement);
    console.log("heroImageOverlay:", heroImageOverlay);
    console.log("heroContent:", heroContent);
    console.log("window.gsap:", window.gsap);
  }
}

// ===== DYNAMIC GRADIENT POSITIONING =====
function updateGradientPosition() {
  if (window.innerWidth > 480) return; // Only for mobile

  const heroImageElement = document.querySelector(".hero-image-element");
  const heroSection = document.querySelector(".hero-section");

  if (!heroImageElement || !heroSection) return;

  // Get the hero image's actual computed position
  const imageRect = heroImageElement.getBoundingClientRect();
  const sectionRect = heroSection.getBoundingClientRect();

  // Calculate the image's position relative to the hero section
  const topOffset = imageRect.top - sectionRect.top;
  const leftOffset = imageRect.left - sectionRect.left;
  const rightOffset = sectionRect.right - imageRect.right;

  // Add insets to ensure the gradient stays within the image boundaries
  const topInset = 4;
  const sideInset = 1; // 1px inset from sides

  // Update CSS custom properties for dynamic positioning with insets
  heroSection.style.setProperty("--gradient-top", `${topOffset + topInset}px`);
  heroSection.style.setProperty(
    "--gradient-left",
    `${leftOffset + sideInset}px`
  );
  heroSection.style.setProperty(
    "--gradient-right",
    `${rightOffset + sideInset}px`
  );

  console.log("Gradient position updated:", {
    topOffset: topOffset + topInset,
    leftOffset: leftOffset + sideInset,
    rightOffset: rightOffset + sideInset,
  });
}

// ===== MOBILE DETECTION UTILITY =====
function isMobile() {
  return window.innerWidth <= 1024;
}

// ===== EXPANDING SECTION ANIMATION =====
function initExpandingSection() {
  const expandingSection = document.getElementById("expanding-section");
  const expandingSectionWrapper = document.getElementById(
    "expanding-section-wrapper"
  );
  const sectionFg = document.querySelector(".section-fg");
  const sectionBgImage = document.querySelector(".section-bg-image");
  const sectionBgColor = document.querySelector(".section-bg-color");
  const sectionContentInitial = document.querySelector(
    ".section-content-initial"
  );
  const sectionContentReveal = document.querySelector(
    ".section-content-reveal"
  );
  const sectionFgImage = document.querySelector(".section-fg-image");
  const sectionFgImageContainer = document.querySelector(
    ".section-fg-image-container"
  );

  if (expandingSection && sectionFg && window.gsap && window.ScrollTrigger) {
    console.log(window.innerWidth);
    // Branch between mobile and desktop implementations
    if (isMobile()) {
      initMobileExpandingSection(
        expandingSectionWrapper,
        sectionBgImage,
        sectionBgColor,
        sectionContentReveal
      );
    } else {
      initDesktopExpandingSection(
        expandingSection,
        sectionFg,
        sectionBgImage,
        sectionBgColor,
        sectionContentInitial,
        sectionContentReveal,
        sectionFgImage,
        sectionFgImageContainer
      );
    }
  } else {
    console.log("Expanding section elements not found or GSAP not loaded");
    console.log("expandingSection:", expandingSection);
    console.log("sectionFg:", sectionFg);
    console.log("window.gsap:", window.gsap);
    console.log("window.ScrollTrigger:", window.ScrollTrigger);
  }
}

// ===== MOBILE EXPANDING SECTION ANIMATION =====
function initMobileExpandingSection(
  expandingSectionWrapper,
  sectionBgImage,
  sectionBgColor,
  sectionContentReveal
) {
  console.log("init mobile expanding section new");
  // Set initial states
  gsap.set(sectionBgColor, { opacity: 0 });
  // gsap.set(sectionContentReveal, { opacity: 0, visibility: "hidden" });

  // Create discrete toggle ScrollTrigger (no scrub, no timeline)
  ScrollTrigger.create({
    trigger: expandingSectionWrapper,
    start: "top 50%",
    toggleActions: "play none reverse none",
    onEnter: () => {
      console.log("Mobile: Entering section - activating animation");
      // Animate to blue background and show reveal content
      gsap.to(sectionBgImage, {
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
      });
      gsap.to(sectionBgColor, {
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
      });
      gsap.to(sectionContentReveal, {
        opacity: 1,
        visibility: "visible",
        duration: 1,
        delay: 0.25,
        ease: "power2.inOut",
      });
    },
    onLeaveBack: () => {
      console.log(
        "Mobile: Leaving section (scrolling back up) - reversing animation"
      );
      // Reverse: back to image background and hide reveal content
      gsap.to(sectionBgImage, {
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
      });
      gsap.to(sectionBgColor, {
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
      });
      gsap.to(sectionContentReveal, {
        opacity: 0,
        visibility: "hidden",
        duration: 1,
        ease: "power2.inOut",
      });
    },
  });

  console.log(
    "Mobile expanding section animation initialized with discrete toggle"
  );
}

// ===== DESKTOP EXPANDING SECTION ANIMATION =====
function initDesktopExpandingSection(
  expandingSection,
  sectionFg,
  sectionBgImage,
  sectionBgColor,
  sectionContentInitial,
  sectionContentReveal,
  sectionFgImage,
  sectionFgImageContainer
) {
  console.log("init desktop expanding section");
  // Create scroll-driven animation timeline
  const expandTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: document.getElementById("expanding-section-wrapper"),
      start: "top top",
      end: "+=200%",
      scrub: 1,
      pin: true,
      anticipatePin: 1,
      refreshPriority: -1,
    },
  });

  // Calculate expansion dimensions - expand to full container width
  const sectionRect = expandingSection.getBoundingClientRect();
  const expandToWidth = sectionRect.width; // Full section width for curtain effect

  // Set higher z-index for the expanding section to create curtain effect
  gsap.set(sectionFg, {
    zIndex: 10,
  });

  // Animation sequence phases - curtain effect
  expandTimeline
    // Phase 1: Container width expansion to cover right content (0% - 50%)
    .to(
      sectionFg,
      {
        width: expandToWidth + "px",
        duration: 0.5,
        ease: "power2.inOut",
      },
      0
    )

    // Phase 2: Background image fade out, color fade in (25% - 75%)
    .to(
      sectionBgImage,
      {
        opacity: 0,
        duration: 0.3,
        ease: "power2.inOut",
      },
      0.25
    )
    .to(
      sectionBgColor,
      {
        opacity: 1,
        duration: 0.3,
        ease: "power2.inOut",
      },
      0.25
    )

    // Phase 3: Initial content fade out (20% - 40%)
    .to(
      sectionContentInitial,
      {
        opacity: 0,
        duration: 0.2,
        ease: "power2.inOut",
      },
      0.2
    )

    // Phase 4: Reveal content fade in (30% - 60%)
    .to(
      sectionContentReveal,
      {
        opacity: 1,
        visibility: "visible",
        duration: 0.3,
        ease: "power2.inOut",
      },
      0.3
    );

  console.log(
    "Desktop expanding section animation initialized with curtain effect"
  );

  // Debug reveal content
  if (sectionContentReveal) {
    console.log("Reveal content found:", sectionContentReveal);
    console.log(
      "Initial reveal content styles:",
      window.getComputedStyle(sectionContentReveal)
    );
    console.log("Desktop curtain reveal animation setup complete");
  } else {
    console.log("Reveal content NOT found");
  }
}

// Step reveal functions have been moved to step-reveal.js module

// ===== RESPONSIVE TESTIMONIAL TEXT SIZING =====
function initResponsiveTestimonialText() {
  const testimonialElements = document.querySelectorAll(
    '.testimonial-text[data-auto-resize="true"]'
  );

  if (testimonialElements.length === 0) return;

  function calculateOptimalFontSize(element) {
    const container = element.closest(".section-content-reveal");
    if (!container) return;

    // Get container dimensions
    const containerRect = container.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const containerHeight = containerRect.height;

    // Account for padding (10vw 10vw 5vw 5vw on desktop, 0 1.5rem on mobile)
    const isMobile = window.innerWidth <= 768;
    let availableWidth, availableHeight;

    if (isMobile) {
      availableWidth = containerWidth - 1.5 * 16 * 2; // 1.5rem padding on each side
      availableHeight = containerHeight * 0.6; // Leave space for author and button
    } else {
      const vwUnit = window.innerWidth / 100;
      availableWidth = containerWidth - 15 * vwUnit; // 10vw + 5vw padding
      availableHeight = containerHeight * 0.5; // Leave space for author and button
    }

    // Get text content and length
    const textContent = element.textContent.trim();
    const textLength = textContent.length;

    // Base font sizes for different screen sizes
    let baseFontSize, minFontSize, maxFontSize;

    if (isMobile) {
      baseFontSize = 20; // 1.25rem
      minFontSize = 16; // 1rem
      maxFontSize = 24; // 1.5rem
    } else {
      baseFontSize = 36; // 2.25rem
      minFontSize = 24; // 1.5rem
      maxFontSize = 48; // 3rem
    }

    // Calculate font size based on text length
    let fontSize = baseFontSize;

    // Text length thresholds for scaling
    if (textLength > 500) {
      fontSize = minFontSize;
    } else if (textLength > 350) {
      fontSize = minFontSize + (baseFontSize - minFontSize) * 0.3;
    } else if (textLength > 200) {
      fontSize = minFontSize + (baseFontSize - minFontSize) * 0.6;
    } else if (textLength < 100) {
      fontSize = Math.min(maxFontSize, baseFontSize * 1.2);
    }

    // Fine-tune based on actual rendered dimensions
    element.style.fontSize = fontSize + "px";
    element.style.lineHeight = "1.25";

    // Check if text overflows and adjust if needed
    const textRect = element.getBoundingClientRect();
    let iterations = 0;
    const maxIterations = 10;

    while (
      (textRect.height > availableHeight || textRect.width > availableWidth) &&
      fontSize > minFontSize &&
      iterations < maxIterations
    ) {
      fontSize -= 2;
      element.style.fontSize = fontSize + "px";
      const newTextRect = element.getBoundingClientRect();
      if (
        newTextRect.height <= availableHeight &&
        newTextRect.width <= availableWidth
      ) {
        break;
      }
      iterations++;
    }

    // Ensure we don't go below minimum
    fontSize = Math.max(fontSize, minFontSize);
    element.style.fontSize = fontSize + "px";

    // Add smooth transition
    element.style.transition = "font-size 0.3s ease";
  }

  function resizeTestimonialText() {
    testimonialElements.forEach(calculateOptimalFontSize);
  }

  // Initial resize
  setTimeout(resizeTestimonialText, 100);

  // Resize on window resize with debouncing
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resizeTestimonialText, 250);
  });

  // Resize when testimonial becomes visible (for the expanding section animation)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        (mutation.attributeName === "class" ||
          mutation.attributeName === "style")
      ) {
        const target = mutation.target;
        if (
          target.classList.contains("section-content-reveal") &&
          target.classList.contains("visible")
        ) {
          setTimeout(resizeTestimonialText, 100);
        }
      }
    });
  });

  // Observe the reveal container for visibility changes
  const revealContainer = document.querySelector(".section-content-reveal");
  if (revealContainer) {
    observer.observe(revealContainer, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }
}

// ===== MAIN INITIALIZATION =====
document.addEventListener("DOMContentLoaded", function () {
  // GSAP initialization check
  if (window.gsap && window.ScrollTrigger) {
    initHeroAnimation();
    initExpandingSection();
  } else {
    let attempts = 0;
    const maxAttempts = 50;
    const checkGSAP = setInterval(() => {
      attempts++;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(checkGSAP);
        initHeroAnimation();
        initExpandingSection();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkGSAP);
        console.warn(
          "GSAP not loaded after 5 seconds, hero and expanding section animations disabled"
        );
      }
    }, 100);
  }

  // Add resize listener for gradient positioning and expanding section
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateGradientPosition();
      if (window.gsap && window.ScrollTrigger) {
        // Kill existing ScrollTriggers for expanding section
        ScrollTrigger.getAll().forEach((trigger) => {
          if (
            trigger.trigger &&
            (trigger.trigger.id === "expanding-section-wrapper" ||
              trigger.trigger.classList.contains("expanding-section"))
          ) {
            trigger.kill();
          }
        });

        // Reinitialize expanding section
        initExpandingSection();
      }
    }, 250);
  });

  // Initial gradient position update
  setTimeout(updateGradientPosition, 100);

  // Initialize responsive testimonial text sizing
  initResponsiveTestimonialText();

  // Step reveal initialization is now handled by the step-reveal.js module
});
